export default "<footer class=\"footer\">\r\n</footer>\r\n";